/**
 * Registers a global Pristine `phone` validator (side-effect import).
 *
 * Apply it to an input with the `data-pristine-phone` attribute. The validator is lenient
 * on format (accepts whatever the live formatter produces, plus bare digits) — it only
 * checks the value reduces to a valid 10-digit NANP number, mirroring the server-side
 * `phoneNumber` rule. NANP-only — see app/Libraries/PhoneUtils.
 */

import Pristine from 'pristinejs';
import { isValidPhone, PHONE_FORMAT_MESSAGE } from '../../../app/Libraries/PhoneUtils';

Pristine.addValidator(
  'phone',
  (value: string) => !value || isValidPhone(value),
  PHONE_FORMAT_MESSAGE,
  2,
  false,
);
